const wrapperCls = "c2lw1nu00jc";
const iframeCls = "c2li8y4ko6";
const subheadingCls = "c2ls1k9ggty";
const bodyCls = "c2lb17u4sbq";

export { bodyCls, iframeCls, subheadingCls, wrapperCls };
import "./empty.style.linaria.module.css";
//# sourceMappingURL=empty.style.js.map
